
import React from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

const AccountLoading = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-gray-50">
      <Header />
      <main className="container mx-auto px-4 py-8 max-w-5xl">
        <div className="flex justify-center items-center h-64">
          <div className="animate-pulse text-[#4A607B]">Loading your account data...</div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default AccountLoading;
